<template>
  <div
    v-element-loader="{ endpoint: 'order' }"
    class="my-pages">
    <validation-observer
      ref="observer"
      tag="form">
      <div class="my-pages__content-grid order-return__top-grid">
        <div class="input-column">
          <div class="my-pages__actions">
            <div class="my-pages-template__action">
              <oie-base-action theme="flat" @click="goBack">
                <template #iconPrepend>
                  <oie-base-icon icon="arrow-left" size="s"></oie-base-icon>
                </template>
                {{ tStatic('goBack') }}
              </oie-base-action>
            </div>

            <!--
  <a :href="clientModel.orderHistoryUrl" class="navigational-item navigational-item--arrow navigational-item--white navigational-item--tab">
    {{ tStatic('orderHistoryMenuItem') }}
  </a>
    -->
          </div>
        </div>

        <div class="input-column">
          <div>
            <h2 v-epi-edit="'OrderHistoryHeader'" class="my-pages__page-type-header">
              {{ t('orderReturnHeader') }}
            </h2>
          </div>
        </div>
      </div>

      <div class="grid grid--three history-details__information">
        <div class="history-details__information-box">
          <h3
            v-epi-edit="'orderInformationHeader'"
            class="history-details__information-header">
            {{ t("orderInformationHeader") }}
            <!-- Ordernummer information -->
          </h3>

          <div class="history-details__information-details">
            <div class="history-details__information-details-row">
              <div v-epi-edit="'orderNumberLabel'" class="history-details__information-details-key">
                {{ t("orderNumberLabel") }}
              </div>
              <div class="history-details__information-details-value">
                {{ order.orderHead.orderNr }}
              </div>
            </div>

            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'orderDateLabel'"
                class="history-details__information-details-key">
                {{ t("orderDateLabel") }}
                <!-- Beställningssatum: -->
              </div>
              <div class="history-details__information-details-value">
                {{ order.orderHead.displayOrderDate }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="orderReturn.issueKey" class="history-details__information-box">
          <h3
            v-epi-edit="'orderInformationHeader'"
            class="history-details__information-header">
            {{ 'Retur/reklamation' }}
            <!-- Ordernummer information -->
          </h3>

          <div class="history-details__information-details">
            <div class="history-details__information-details-row">
              <div v-epi-edit="'orderNumberLabel'" class="history-details__information-details-key">
                {{ 'Ärendenummer' }}
              </div>
              <div class="history-details__information-details-value">
                <span v-if="!orderReturn.isSuperUser">{{ orderReturn.issueKey }}</span>
                <span v-if="orderReturn.isSuperUser"><a target="_blank" :href="'https://olssonparts.atlassian.net/jira/servicedesk/projects/CS/queues/custom/78/' + encodeURIComponent(orderReturn.issueKey)">{{ orderReturn.issueKey }}</a></span>
              </div>
            </div>

            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'orderDateLabel'"
                class="history-details__information-details-key">
                {{ 'Status' }}
                <!-- Beställningssatum: -->
              </div>
              <div class="history-details__information-details-value">
                {{ orderReturn.statusName }}
              </div>
            </div>

            <div v-if="orderReturn.rma != ''" class="history-details__information-details-row">
              <div
                v-epi-edit="'orderDateLabel'"
                class="history-details__information-details-key">
                {{ 'RMA' }}
              </div>
              <div class="history-details__information-details-value">
                <span v-if="!orderReturn.isSuperUser">{{ orderReturn.rma }}</span>
                <span v-if="orderReturn.isSuperUser"><a target="_blank" :href="(t('businessCentralRmaUrl') || '').replace('{rma}', orderReturn.rma)">{{ orderReturn.rma }}</a></span>
              </div>
            </div>

            <div v-if="orderReturn.consignmentNoteUrl != null && orderReturn.consignmentNoteUrl != ''" class="history-details__information-details-row">
              <div
                v-epi-edit="'orderDateLabel'"
                class="history-details__information-details-key">
                {{ 'Returadresskort' }}
              </div>
              <div class="history-details__information-details-value">
                <a :href="orderReturn.consignmentNoteUrl">Ladda ner</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <oie-message-box v-if="!orderReturn.returnsPossible && orderReturn.issueKey === null" class="message-box--orange message-box--compact order-return-message">
          <svg
            v-if="mq('small')"
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          {{ t('returnsNotPossibleDescription') }}
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="!orderReturn.complaintReturnsPossible && orderReturn.issueKey === null" class="message-box--orange message-box--compact order-return-message">
          <svg
            v-if="mq('small')"
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          {{ t('complaintReturnsNotPossibleDescription') }}
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="orderReturn.issueKey && !orderReturn.rma" class="message-box--green message-box--compact order-return-message">
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          <span v-html="orderReturnConfirmationDescription"></span>
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="orderReturn.rma" class="message-box--green message-box--compact order-return-message">
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          <span v-html="(t('rmaCreatedMessage') || '').replace('{RMA}', orderReturn.rma)"></span>
        </oie-message-box>
      </div>

      <oie-base-accordion-toggler
        v-if="orderReturn.issueKey !== null"
        :is-open="isReturnActionsOpen"
        :text="t('orderReturnNewReturnButtonText')"
        class="new-return__toggler"
        @click="createNewReturn()">
      </oie-base-accordion-toggler>

      <div v-if="isReturnActionsOpen" class="order-return-container__return-options">
        <div class="order-return-container__return-options-container">
          <h2 class="order-return-container__section-heading">
            {{ t('selectArticlesHeading') }}
          </h2>

          <div class="order-return-container__radio-buttons">
            <oie-base-radio
              v-for="method in returnOptions"
              :id="`${method.id}_i`"
              :key="method.id"
              :value="method.id"
              :is-checked="returnOptionID === method.id"
              :label-text="`${method.name}`"
              :use-sub-text="true"
              css-classes="radio--blue"
              name="shipping-type"
              @click="setReturnOptionID(method.id)">
              <span class="radio__label-sub-text-container">
                {{ method.description }}
              </span>
            </oie-base-radio>
          </div>
        </div>

        <div v-if="returnOptionID === 1" class="order-return-container__full-order">
          <div class="input-column">
            <div class="input-column__container">
              <validation-provider
                v-if="returnOptionID === 1"
                name="full-order-return-reason"
                rules="required"
                slim>
                <template slot-scope="{ errors }">
                  <oie-base-dropdown
                    v-model="orderReturn.fullOrderReturnReasonID"
                    :initial-text="tStatic('orderReturnReasonDropdownText')"
                    :options="orderReturnReasonOptions"
                    :is-large="false"
                    :use-full-width="true"
                    :use-thin-border="true"
                    :label-text="t('reasonLabel')"
                    :error-message="errors[0]"></oie-base-dropdown>
                </template>
              </validation-provider>

              <validation-provider
                v-if="orderReturn.fullOrderReturnReasonID"
                name="full-order-return-description"
                rules="required"
                slim>
                <template slot-scope="{ errors }">
                  <oie-base-input
                    v-show="orderReturn.fullOrderReturnReasonID"
                    id="fullOrderReturnReason"
                    v-model="orderReturn.fullOrderReturnReasonDescription"
                    textarea="true"
                    max-length="2000"
                    :label-text="t('fullOrderReturnDescriptionLabel')"
                    :placeholder="tStatic('orderReturnReasonDescriptionPlaceholder')"
                    :error-messages="errors"></oie-base-input>
                </template>
              </validation-provider>

              <oie-base-input
                v-show="orderReturn.fullOrderReturnReasonID === 3 || orderReturn.fullOrderReturnReasonID === 4 || orderReturn.fullOrderReturnReasonID === 5"
                v-model="orderReturn.fullOrderReturnMachineType"
                :label-text="t('vehicleTypeLabel')"
                :placeholder="tStatic('orderReturnMachineTypePlaceholder')"></oie-base-input>

              <oie-base-input
                v-show="orderReturn.fullOrderReturnReasonID === 3 || orderReturn.fullOrderReturnReasonID === 4 || orderReturn.fullOrderReturnReasonID === 5"
                v-model="orderReturn.fullOrderReturnSerialNumber"
                label-text="t('serialNumberLabel')"
                :placeholder="tStatic('orderReturnSerialNumberPlaceholder')"></oie-base-input>
            </div>
          </div>
        </div>
      </div>

      <div v-if="returnOptionID === 2 && isReturnActionsOpen && (orderReturn.returnsPossible || orderReturn.complaintReturnsPossible)" class="history-details-products">
        <!--
      <div v-epi-edit="'orderRowsHeader'" class="history-details-products__top">
        {{ t("orderRowsHeader") }}
      </div>
        -->

        <oie-order-return-product-table
          v-if="isReturnActionsOpen"
          :order-return="orderReturn"
          :rows="order.orderRows"
          :returns-possible="orderReturn.returnsPossible"
          :complaint-returns-possible="orderReturn.complaintReturnsPossible"
          :is-super-user="orderReturn.isSuperUser"
          class="order-return-container_products"></oie-order-return-product-table>
      </div>

      <div v-if="isReturnActionsOpen && (orderReturn.returnsPossible || orderReturn.complaintReturnsPossible)" class="history-details-products">
        <h2 class="order-return-container__section-heading">
          {{ t("attachImagesOrVideoHeading") }}
        </h2>

        <oie-order-return-file-upload :order-number="orderNumber" :token="token" class="order-return-container__order-return-file-upload"></oie-order-return-file-upload>
      </div>

      <div v-if="isReturnActionsOpen && !orderReturn.isSuperUser" class="order-return-repayment">
        <div>
          <h2 v-epi-edit="'OrderReturnStatusHeading'" class="order-return-container__section-heading">
            {{ t('orderReturnRepaymentHeading') }}
          </h2>
          <oie-base-dropdown
            v-model="repaymentOptionID"
            :initial-text="tStatic('orderReturnRepaymentDropdownText')"
            :options="repaymentOptions"
            :is-large="false"
            :is-for="`history-details-product-${key}`"
            :block-id="`history-details-product-${key}`"
            :use-full-width="true"
            :use-thin-border="true"
            :default-selected="defaultRepaymentOption"></oie-base-dropdown>

          <validation-provider
            v-if="repaymentOptionID === '2'"
            name="bank-account-number"
            rules="required"
            slim>
            <template slot-scope="{ errors }">
              <oie-base-input
                v-show="repaymentOptionID === '2'"
                id="bank-account-number"
                v-model="repaymentBankAccountNumber"
                :placeholder="tStatic('orderReturnRepaymentBankAccountNumberPlaceholder')"
                :error-messages="errors"></oie-base-input>
            </template>
          </validation-provider>
        </div>
      </div>

      <oie-order-return-contact-info v-if="isReturnActionsOpen" :order-number="orderNumber" :token="token"></oie-order-return-contact-info>

      <div v-if="isReturnActionsOpen" class="order-return-create-rma">
        <h2 v-epi-edit="'OrderReturnStatusHeading'" class="order-return-container__section-heading">
          {{ 'RMA' }}
        </h2>

        <div class="create-rma-along-with-issue">
          <oie-base-checkbox
            v-model="createRmaAlongWithIssue"
            is-for="order-return-create-rma"
            :text="t('createRmaLabel')"></oie-base-checkbox>
        </div>
      </div>

      <div v-if="isReturnActionsOpen && !createRmaAlongWithIssue" class="order-return-container__actions-container">
        <div class="order-return-container__actions-right">
          <oie-base-button
            v-epi-edit="'createOrderReturnButtonLabel'"
            :text="t('addToCartButtonLabel')"
            :disabled="orderReturn.fullOrderReturnReasonID == null && selectedReturnRows.length === 0"
            css-classes="button--with-border button--green order-return-container__action-button"
            :use-full-width="true"
            @click="createOrderReturn"></oie-base-button>
        </div>
      </div>
    </validation-observer>

    <oie-base-accordion-toggler
      v-if="orderReturn.issueKey !== null && !createRmaAlongWithIssue"
      :is-open="isSuperuserSectionOpen"
      :text="t('createRmaLabel')"
      class="superuser-section__toggler"
      @click="toogleSuperuserSection()">
    </oie-base-accordion-toggler>

    <oie-order-return-superuser
      v-show="(isSuperuserSectionOpen && orderReturn.issueKey) || createRmaAlongWithIssue"
      :issue-key="orderReturn.issueKey"
      :order-number="orderNumber"
      :create-rma-along-with-issue="createRmaAlongWithIssue"></oie-order-return-superuser>

    <div v-if="orderReturn.issueKey" class="history-details-products">
      <oie-order-return-issue-tracking
        :rows="issueMessages"
        :order-return="orderReturn"
        :order="order"
        class="history-details-products__table"></oie-order-return-issue-tracking>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  props: {
    orderNumber: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    createRmaAlongWithIssue: false,
    isReturnActionsOpen: false,
    isSuperuserSectionOpen: false,
    repaymentOptionID: null,
    repaymentBankAccountNumber: null,
    orderReturnConfirmationDescription: null,
    selectedReturnRows: [],
    issueMessages: [],
    customerRepresentativeFirstName: null,
    orderReturn: {
      issueKey: null,
      statusName: '',
      isBillableClient: false,
      returnsPossible: true,
      complaintReturnsPossible: true,
      orderReturnIssue: null,
      isSuperUser: false,
      fullOrderReturnReasonID: null,
      fullOrderReturnReasonDescription: null,
      fullOrderReturnMachineType: null,
      fullOrderReturnSerialNumber: null,
      uploadedFiles: [],
      shippingCost: 0,
      shippingAgent: null,
      shippingAgentService: null,
      documentToCustomer: null,
      rma: null,
      consignmentNoteUrl: null
    },
    returnOptions: [],
    returnOptionID: 2,
    order: {
      orderHead: {
        orderNr: '',
        orderDate: '',
        displayOrderDate: '',
        customerNo: '',
        currency: '',
        paymentTerms: '',
        modeOfDelivery: '',
        shipmentId: '',
        ourRef: '',
        invoiceRefernce: '',
        shipmentCost: 0,
        packagingCost: 0,
        vatSum: 0,
        orderSum: 0,
        comment: '',
        goodsInformationNo: '',
        goodsInformationUrl: '',
        deliveryAddress: {
          name: '',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        },
        invoiceAddress: {
          name: '',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        }
      },
      orderRows: []
    }
  }),
  computed: {
    repaymentOptions() {
      return [
        { text: this.tStatic('orderReturnRepaymentDropdownOption1'), value: '1' },
        { text: this.tStatic('orderReturnRepaymentDropdownOption2'), value: '2' }
      ]
    },
    orderReturnReasonOptions() {
      let reasons = []

      if (this.orderReturn.returnsPossible || this.orderReturn.isSuperUser) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption1'), value: 1 })
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption2'), value: 2 })
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption3'), value: 3 })
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption4'), value: 4 })
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption6'), value: 6 })
      }

      if (this.orderReturn.complaintReturnsPossible || this.orderReturn.isSuperUser) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption5'), value: 5 })
      }

      // 9 customizable options for customer service
      let superUserOnlyKeyword = '- Intern -'

      if (this.tStatic('orderReturnReasonDropdownOption7') && (!this.tStatic('orderReturnReasonDropdownOption7').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption7'), value: 7 })
      }

      if (this.tStatic('orderReturnReasonDropdownOption8') && (!this.tStatic('orderReturnReasonDropdownOption8').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption8'), value: 8 })
      }

      if (this.tStatic('orderReturnReasonDropdownOption9') && (!this.tStatic('orderReturnReasonDropdownOption9').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption9'), value: 9 })
      }

      if (this.tStatic('orderReturnReasonDropdownOption10') && (!this.tStatic('orderReturnReasonDropdownOption10').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption10'), value: 10 })
      }

      if (this.tStatic('orderReturnReasonDropdownOption11') && (!this.tStatic('orderReturnReasonDropdownOption11').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption11'), value: 11 })
      }

      if (this.tStatic('orderReturnReasonDropdownOption12') && (!this.tStatic('orderReturnReasonDropdownOption12').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption12'), value: 12 })
      }

      if (this.tStatic('orderReturnReasonDropdownOption13') && (!this.tStatic('orderReturnReasonDropdownOption13').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption13'), value: 13 })
      }

      if (this.tStatic('orderReturnReasonDropdownOption14') && (!this.tStatic('orderReturnReasonDropdownOption14').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption14'), value: 14 })
      }

      if (this.tStatic('orderReturnReasonDropdownOption15') && (!this.tStatic('orderReturnReasonDropdownOption15').includes(superUserOnlyKeyword) || this.orderReturn.isSuperUser)) {
        reasons.push({ text: this.tStatic('orderReturnReasonDropdownOption15'), value: 15 })
      }

      return reasons
    },
    defaultRepaymentOption() {
      if (!this.orderReturn.isBillableClient) {
        return '2'
      }

      return '1'
    }
  },
  created() {
    this.returnOptions = [
      { id: 2, name: this.t('returnSomeArticles'), description: this.t('returnSomeArticlesDescription') },
      { id: 1, name: this.t('wholeOrder'), description: this.t('wholeOrderDescription') }
    ]
  },
  mounted() {
    if (this.orderNumber !== '') {
      // Load order
      httpService
        .get(`order-return/${this.orderNumber}/order`, { token: this.token })
        .then(response => {
          this.order = response.data
        })

      // Load order return
      httpService
        .get(`order-return/${this.orderNumber}`, { token: this.token })
        .then(response => {
          this.orderReturn = response.data
          this.orderReturnConfirmationDescription = this.tStatic('orderReturnConfirmationDescription') + '<strong>' + this.orderReturn.issueKey + '</strong>'

          if (this.orderReturn === null || this.orderReturn.issueKey === null) {
            this.isReturnActionsOpen = true
          }
        })

      // Load issue messages
      httpService
        .get(`order-return/${this.orderNumber}/issue`, { token: this.token })
        .then(response => {
          this.issueMessages = response.data.messages
        })
    }

    this.subscribe('order-return-rows-selection-updated', rows => {
      this.selectedReturnRows = rows
    })

    this.subscribe('order-return-superuser-updated', superuserOptions => {
      this.orderReturn.shippingCost = superuserOptions.shippingCost
      this.orderReturn.shippingAgent = superuserOptions.shippingAgent
      this.orderReturn.shippingAgentService = superuserOptions.shippingAgentService
      this.orderReturn.documentToCustomer = superuserOptions.documentToCustomer
      this.orderReturn.rma = superuserOptions.rma
      this.orderReturn.consignmentNoteUrl = superuserOptions.consignmentNoteUrl

      if (superuserOptions.createOrderReturnAndRma) {
        this.createOrderReturn()
        this.createRmaAlongWithIssue = false
      }
    })

    this.subscribe('order-return-superuser-rma-created', superuserOptions => {
      this.isSuperuserSectionOpen = false
    })

    this.subscribe('order-return-contact-info-updated', customer => {
      this.customerRepresentativeFirstName = customer.firstName
      this.customerRepresentativeLastName = customer.lastName
      this.customerRepresentativeTelephoneNumber = customer.phone
      this.customerRepresentativeEmailAddress = customer.email
    })

    this.subscribe('order-return-file-uploaded', (response) => {
    })

    this.subscribe('order-return-file-upload-updated', newUploadedFiles => {
      this.uploadedFiles = newUploadedFiles
    })
  },
  methods: {
    createOrderReturn() {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          document.body.scrollTop = 0 // For Safari
          document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

          const products = _.map(this.selectedReturnRows, item => {
            return { itemId: item.artNr, quantity: item.quantity, returnReasonId: item.returnReasonId, returnReasonDescription: item.returnReasonDescription, machineType: item.machineName, serialNumber: item.serialNumber }
          })

          const orderReturnJson = {
            orderNumber: this.orderNumber,
            products: products,
            repaymentOptionId: this.repaymentOptionID,
            repaymentBankAccountNumber: this.repaymentBankAccountNumber,
            customerRepresentativeFirstName: this.customerRepresentativeFirstName,
            customerRepresentativeLastName: this.customerRepresentativeLastName,
            customerRepresentativeTelephoneNumber: this.customerRepresentativeTelephoneNumber,
            customerRepresentativeEmailAddress: this.customerRepresentativeEmailAddress,
            returnOptionID: this.returnOptionID,
            fullOrderReturnReasonID: this.orderReturn.fullOrderReturnReasonID,
            fullOrderReturnReasonDescription: this.orderReturn.fullOrderReturnReasonDescription,
            fullOrderReturnMachineType: this.orderReturn.fullOrderReturnMachineType,
            fullOrderReturnSerialNumber: this.orderReturn.fullOrderReturnSerialNumber,
            uploadedFiles: this.uploadedFiles,
            shippingCost: this.orderReturn.shippingCost,
            shippingAgent: this.orderReturn.shippingAgent,
            shippingAgentService: this.orderReturn.shippingAgentService,
            documentToCustomer: this.orderReturn.documentToCustomer
          }

          httpService.post(`order-return/${this.orderNumber}/create-return?token=${this.token}`, orderReturnJson).then((response) => {
            this.orderReturn = response.data
            this.orderReturnConfirmationDescription = this.tStatic('orderReturnConfirmationDescription') + '<strong>' + response.data.issueKey + '</strong>'
            this.orderReturn.statusName = 'Created'
            this.isReturnActionsOpen = false

            httpService
              .get(`order-return/${this.orderNumber}`, { token: this.token })
              .then(response => {
                this.orderReturn = response.data

                this.publish('order-return-created', this.orderReturn)
              })

            httpService
              .get(`order-return/${this.orderNumber}/issue`, { token: this.token })
              .then(response => {
                this.issueMessages = response.data.messages
              })
          })
        }
      })
    },
    setReturnOptionID(id) {
      this.returnOptionID = id
    },
    createNewReturn() {
      this.isReturnActionsOpen = !this.isReturnActionsOpen
    },
    toogleSuperuserSection() {
      this.isSuperuserSectionOpen = !this.isSuperuserSectionOpen
    },
    goBack() {
      window.location.href = this.clientModel.orderHistoryUrl
    }
  }
}
</script>

<style lang="scss">
  .main--history-details {
    @include container;
    padding-top: measure(double);
    padding-bottom: measure(double);
  }

  .history-details__top {
    margin-bottom: measure(double);
  }

  .history-details__header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .history-details__information {
    margin-bottom: measure(half);
  }

  .history-details__phone-link {
    margin-top: measure(quarter);
    color: color(text-blue);
  }

  .history-details__information-box {
    @include body-smaller;
    background-color: color(background-white);
    border: 1px solid color(border-gray);
    padding: measure(half);
  }

  .history-details__information-header {
    @include h3-semi-bold;
    margin-top: 0;
  }

  .history-details__information-details-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: measure(eighth);
  }

  .history-details__information-details-key,
  .history-details__information-details-value {
    flex-basis: 50%;
  }

  .history-details__information-address-row {
    margin-bottom: measure(eighth);
  }

  .history-details-products__top {
    @include body-semi-bold;
    display: flex;
    align-items: center;
    padding: measure(quarter) 0;
  }

  .history-details-products__table {
    margin-bottom: measure(half);
  }

  .history-details-products__summary {
    @include body-smaller;
    background-color: color(background-white);
    border: 1px solid color(border-gray);
    margin-bottom: measure(half);
    padding: measure(half);

    @include media(medium) {
      @include body;
    }
  }

  .history-details-products__summary-row {
    display: flex;
    flex-direction: column;
    margin-bottom: measure(half);

    &:last-child {
      margin-bottom: 0;
    }

    @include media(medium) {
      flex-direction: row;
      margin-bottom: measure(quarter);
    }
  }

  .history-details-products__summary-value {
    @include body-smaller-semi-bold;
    margin-left: 0;
    padding-top: measure(quarter);

    @include media(medium) {
      @include body-smaller-semi-bold;
      margin-left: auto;
      padding-top: 0;
    }
  }

  .history-details-products__summary-value--larger {
    @include body-semi-bold;

    @include media(medium) {
      @include h3-semi-bold;
    }
  }

  .history-details-invoice__container > * {
    vertical-align: middle;
    display: inline;
  }

  .history-details-invoice__number {
    @include reset-link;
    display: flex;
    align-items: center;
    margin-right: measure(quarter);

    & > svg {
      width: 1.4rem;
      height: 1.4rem;
      margin-left: measure(quarter);
    }
  }

  .order-return-container__actions-container {
    display: flex;
    flex-direction: column;

    @include media(medium) {
      flex-direction: row;
      align-items: flex-end;
    }
  }

  .order-return-container__actions-right {
    width: 100%;
    margin-top: 1rem;

    @include media(medium) {
      max-width: 24rem;
      width: 100%;
      margin-left: auto;
    }
  }

  .order-return-container__action-button {
    width: 100%;
  }

  .order-return__top-grid {
    margin-bottom: 1.875rem;
    display: block;
  }

  .order-return-status-heading {
    margin-top: 2.5rem;
    margin-bottom: 0.5rem;
  }

  .order-return-repayment {
    margin-bottom: measure(half);
  }

  .order-return-message {
    margin-bottom: 1.25rem;
  }

  .order-return-container__section-heading {
    font-family: Open Sans, sans-serif;
    font-weight: 600;
    font-size: 1.5em;
    margin-top: 2rem;
    margin-bottom: .4rem;
  }

  .order-return-container__radio-buttons {
    display: flex;
    flex-direction: row;
  }

  .order-return-container__radio-buttons > .radio {
    margin-right: 1rem;
    border: 1px solid #dfdfdf;
    padding: 1rem;
  }

  .order-return-container_products {
    margin-top: 1rem;
  }

  .order-return-container__full-order {
    margin-top: 1rem;
  }

  .new-return__toggler, .superuser-section__toggler {
    margin-top: 2rem;
    font-size: 1.5em !important;
  }

  .new-return__toggler > svg,, .superuser-section__toggler > svg {
    margin-right: .75rem;
  }

  .superuser-section__toggler {
    margin-bottom: 2rem;
  }

  .create-rma-along-with-issue {
    margin-bottom: 1.25rem;
  }

  .dropdown__container {
    z-index: auto !important;
  }

  .my-pages-template__action {
    position: static;
  }
</style>
